// Reusable logging helper for contract/entity changes

function deepEqual(a: any, b: any): boolean {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a === null || b === null) return a === b;
    if (typeof a !== 'object') return a === b;
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    if (Array.isArray(a)) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i])) return false;
      }
      return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (const key of aKeys) {
      if (!bKeys.includes(key)) return false;
      if (!deepEqual(a[key], b[key])) return false;
    }
    return true;
  }
  
  function isScalar(val: any): boolean {
    return (
      val === null ||
      val === undefined ||
      typeof val === 'string' ||
      typeof val === 'number' ||
      typeof val === 'boolean'
    );
  }
  
  function getChangedFields(before: any, after: any): Array<{ field: string; before: any; after: any }> {
    const changed: Array<{ field: string; before: any; after: any }> = [];
    if (!before || !after) return changed;
    const keys = new Set([...Object.keys(before), ...Object.keys(after)]);
    for (const key of keys) {
      if (!deepEqual(before[key], after[key])) {
        changed.push({ field: key, before: before[key], after: after[key] });
      }
    }
    return changed;
  }
  
  export function buildChangeLog({ before, after, userId, action, id, extra = {} }: {
    before: any,
    after: any,
    userId: string,
    action: string,
    id: string,
    extra?: Record<string, any>
  }) {
    const changedFields = getChangedFields(before, after);
    const fieldsChanged = changedFields.reduce((acc, { field, before, after }) => {
      acc[field] = { before, after };
      return acc;
    }, {} as Record<string, { before: any; after: any }>);
    const richMessage = changedFields.length
      ? changedFields.map(f => isScalar(f.before) && isScalar(f.after)
          ? `\n- ${f.field}: '${f.before}' → '${f.after}'`
          : `\n- ${f.field}: [complex value changed]`
        ).join('')
      : `No fields changed.`;
    return {
      message: richMessage,
      changedFields,
      fieldsChanged,
      ...extra,
    };
  }
  